export default __webpack_public_path__ + "static/media/fam2.8b5c5d6f.png";